import React from 'react';

import { Link, RouterLinkProps as LinkProps } from 'src/router/components';
import { settings } from 'src/settings';

export type RelativeLinkProps = Omit<LinkProps, 'to'> & {
  to: string;
  qaId?: string;
  'data-testid'?: string;
};

export default class RelativeLink extends React.PureComponent<RelativeLinkProps> {
  render() {
    const { to, children, className, qaId, ...rest } = this.props;
    return (
      <Link
        className={className}
        data-qa={qaId}
        to={to.replace(settings().CANON_URL, '')}
        {...rest}
      >
        {children}
      </Link>
    );
  }
}
